const actions = {
  SET_STATE: 'accreditation/SET_STATE',
  SET_EVENT_DATA: 'accreditation/SET_EVENT_DATA',
  GET_EVENT_DATA: 'accreditation/GET_EVENT_DATA',
  SET_ACCREDITATION_DATA: 'accreditation/SET_ACCREDITATION_DATA',
  GET_ACCREDITATION_DATA: 'accreditation/GET_ACCREDITATION_DATA',
}

export default actions
